module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("1. H.H. Holmes, America’s First Serial Killer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Lucy Lambert Hale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Governor Wentworth’s Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Judge John Pickering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Isles of Shoals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Lovewell’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. America’s Stonehenge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Mystery Stone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Old Man in the Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Rock Rimmon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Cemeteries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Aleister Crowley’s Retirement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. "), _c('i', [_vm._v("Peyton Place")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. J.D. Salinger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15#C15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Hanging of Ruth Blay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16#C16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Murder of Josie Langmaid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#C17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Overdue Library Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18#C18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Madame Sherri")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19#C19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Frog Eater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20#C20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Fireman’s Riot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21#C21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Suspected Witchcraft")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22#C22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Murder of Jonas L. Parker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0